import { Nav } from '@/components/site/Nav';
import { SqueegeeHero } from '@/components/site/SqueegeeHero';
import { Manifesto } from '@/components/site/Manifesto';
import { Marquee } from '@/components/site/Marquee';
import { Services } from '@/components/site/Services';
import { Testimonials } from '@/components/site/Testimonials';
import { Footer } from '@/components/site/Footer';

export default function Landing() {
  return (
    <div className="app-root">
      <Nav />
      <main>
        <SqueegeeHero />
        <Manifesto />
        <Marquee />
        <Services />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
}
